import { render, staticRenderFns } from "./OrderPackagesDisplay.vue?vue&type=template&id=36ad4dac&scoped=true&"
import script from "./OrderPackagesDisplay.vue?vue&type=script&lang=js&"
export * from "./OrderPackagesDisplay.vue?vue&type=script&lang=js&"
import style0 from "./OrderPackagesDisplay.vue?vue&type=style&index=0&id=36ad4dac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad4dac",
  null
  
)

export default component.exports